/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class UserPreferencesModel {
  name: string | null = null;
  label: string | null = null;
  preferenceJson: string | null = null;

  constructor(name: string | null, label: string | null, preferenceJson: string | null) {
    this.name = name;
    this.label = label;
    this.preferenceJson = preferenceJson;
  }
}
